import React from "react";
import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* comp imports */
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import AboutUsContentWrapper from "../components/AboutUsContentWrapper";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const AboutUs = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };

  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper about-us-page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/" />
        <AboutUsContentWrapper />
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default AboutUs;
